import apiClient from '@/services/http/client'

export interface BrandingData {
  primary_color: string
  secondary_color: string
  background_color: string
  surface_color: string
  text_color: string
  muted_text_color: string
  border_color: string
  radius: number
  mode: 'light' | 'dark' | 'system'
  logo_url?: string | null
}

export interface BrandingResponse {
  ok?: boolean
  data?: {
    branding?: BrandingData
    logo_url?: string
  }
}

export const getBranding = async (studioId: string | number) => {
  const response = await apiClient.get<BrandingResponse>(`/api/v1/studios/${studioId}/branding`, {
    headers: {
      'X-Studio-Id': String(studioId),
    },
  })
  return response.data
}

export const updateBranding = async (studioId: string | number, payload: BrandingData) => {
  const response = await apiClient.put<BrandingResponse>(`/api/v1/studios/${studioId}/branding`, payload, {
    headers: {
      'X-Studio-Id': String(studioId),
    },
  })
  return response.data
}

export const uploadBrandingLogo = async (studioId: string | number, file: File) => {
  const formData = new FormData()
  formData.append('logo', file)
  const response = await apiClient.post<BrandingResponse>(
    `/api/v1/studios/${studioId}/branding/logo`,
    formData,
    {
      headers: {
        'X-Studio-Id': String(studioId),
        'Content-Type': 'multipart/form-data',
      },
    },
  )
  return response.data
}
